var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modalAberto)?_c('modal-padrao',{ref:"modal",attrs:{"titulo":_vm.titulo,"max-width":"90%","mostrar-botoes":false},on:{"modal-fechado":_vm.destruirModal}},[_c('gerador-relatorio',{ref:"gerador",staticStyle:{"min-height":"1000px"},on:{"houve-erro":_vm.destruirModal}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }